export function sortByDate(a: Date, b: Date) {
	return a.getTime() - b.getTime();
}